/**
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import QRious from 'qrious';

import focus from '../focus/focus-directive';
import template from './setup-qr.html';

export default {
  name: 'SetupQr',
  template,
  directives: { focus },
  methods: {
    onManual() {
      this.$emit('manual');
    },
    onSettings() {
      this.$emit('settings');
    }
  },
  mounted() {
    this.qriuous = new QRious({
      element: this.$refs.canvasEl,
      level: 'L',
      size: 340,
      value: this.$root.setupManager.getQrUrl(
        this.serverUrl,
        this.$root.session.fingerprint
      )
    });
  },
  props: ['serverUrl']
};
